/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable eqeqeq */
import React from "react";
import { Table } from "react-materialize";
import Html from "../../utils/Html";

import TrHead from "./main.content.trhead";
import TrContent from "./main.content.trcontent";
import SelectPage from "./main.content.select.page";

export default function RequestsTab({
  userData,
  filters,
  setFilters,
  data,
  loading }) {
  const userID = userData.idu;

  // data รูปแบบที่คาดหวังจาก MainContent.fetchData():
  // {
  //   requests: [],
  //   requests_total: number,
  //   users: {},
  //   photos: {},
  //   total_page: number,
  //   active_page: number,
  //   leaves: ...
  // }

  const requests = data?.requests || data?.data || [];
  const requestsTotal =
    typeof data?.requests_total === "number"
      ? data.requests_total
      : (Array.isArray(data?.data) ? data.data.length : requests.length) || 0;
  const users = data?.users || {};
  const photos = data?.photos || {};
  const totalPage = data?.total_page || 0;
  const activePage = data?.active_page || 1;
  const leaves = data?.leaves;

  return (
    <div id="table-content">
      {!loading && (
        <div id="table-total">
          Total : <span id="table-total__number">{requestsTotal}</span>
        </div>
      )}

      {loading ? (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            padding: "32px 0 24px",
            minHeight: 80 }}
        >
          <Html.Preloading
            addon={{
              css: { position: "static", margin: 0, transform: "none" } }}
          />
        </div>
      ) : (
        <>
          <Table className="highlight table-leave" id="table-leave-requests">
            <thead>
              <TrHead />
            </thead>
            <tbody>
              <TrContent
                data={requests}
                users={users}
                photos={photos}
                userID={userID}
                leaves={leaves}
              />
            </tbody>
          </Table>

          <SelectPage
            totalPage={totalPage}
            activePage={activePage}
            setFilters={setFilters}
            // ให้ parent เป็นคน fetch เมื่อ page เปลี่ยน (ถ้าต้องการ)
            setReqData={() => {}}
          />
        </>
      )}
    </div>
  );
}

